import { z } from "zod";
import apiClient from "../../../shared/api/client";

const activityStatusSchema = z.enum(["success", "warning", "error"]);

export type ActivityStatus = z.infer<typeof activityStatusSchema>;

export const userActivitySchema = z.object({
  id: z.string(),
  userId: z.string(),
  userEmail: z.string().email(),
  userName: z.string(),
  action: z.string(),
  resource: z.string(),
  status: activityStatusSchema,
  createdAt: z.string(),
  metadata: z.record(z.unknown()).nullish(),
});

export type UserActivity = z.infer<typeof userActivitySchema>;

export type UserActivityFilters = {
  user?: string;
  action?: string;
  status?: ActivityStatus | "all";
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
  sortBy?: "user" | "action" | "date";
  sortOrder?: "asc" | "desc";
};

const activityResponseSchema = z.object({
  data: z.array(userActivitySchema),
  meta: z.object({
    page: z.number(),
    pageSize: z.number(),
    total: z.number(),
  }),
});

export type UserActivityResponse = z.infer<typeof activityResponseSchema>;

export const fetchUserActivity = async (
  filters: UserActivityFilters
): Promise<UserActivityResponse> => {
  const response = await apiClient.get("/users/activity", {
    params: {
      user: filters.user,
      action: filters.action,
      status: filters.status === "all" ? undefined : filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
      page: filters.page ?? 1,
      pageSize: filters.pageSize ?? 20,
      sortBy: filters.sortBy,
      sortOrder: filters.sortOrder,
    },
  });

  return activityResponseSchema.parse(response.data);
};
